import axios from 'axios_template';

export const authenticateRequest = (username: string, password: string) => {
    return axios.post('/api/token/', { username, password });
};
